import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "clip-path": "url(#i365696789__a)",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><clipPath id=\"i365696789__a\"><rect width=\"48\" height=\"48\" fill=\"#fff\" rx=\"16\"></rect></clipPath></defs><rect width=\"48\" height=\"48\" rx=\"16\"></rect><path fill=\"#000001\" d=\"M48 0H0v48h48z\"></path><path fill=\"#fff\" d=\"M32.636 19.501h-.084c-1.001-1.633-3.008-2.694-5.59-2.694-4.87 0-7.939 3.466-7.939 8.397 0 4.93 3.069 8.396 7.939 8.396 2.578 0 4.585-1.061 5.59-2.694h.084v2.236h4.183V17.265h-4.183zM28.02 30.162c-3.439 0-4.673-1.576-4.673-4.958s1.23-4.959 4.673-4.959 4.673 1.576 4.673 4.959-1.23 4.958-4.673 4.958M14.953 13.084H10.71v20.06h4.243z\"></path>", 4)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "lamoda"}) } }